import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import BeforeAfter from '../../Create/components/HomeTitle/BeforeAfter'
import headerBg from './header-bg.png'
import img1 from './img1.png'
import img3 from './img3.png'
import img4 from './img4.png'

const AiInteriorDesign = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="AI Interior Design App to Instantly Decorate & Visualize Your Dream Room"
        subtitle={<>Upload your room, pick your style, and get instant AI-generated interior designs. Decorate smarter with the top-rated AI room planner.</>}
        bg={headerBg}
        meta={{
          title: 'AI Interior Design App | Smart Room Planner & AI Decorating Tool',
          description: 'Design your space in minutes with our AI interior design app. Upload your room, select a style, and get instant AI-generated layouts, furniture previews, and decorating ideas.'
        }}
        alt="AI interior design app showing virtual room styles and layouts generated with AI design tools"
      />
      <Join
        title="Join 10M+ Users Decorating Homes with Our"
        postfix="AI Interior Design App"
        description="Discover the fastest way to decorate your home with AI. The DecorMatters AI interior design app helps you transform any room in minutes. Whether you're remodeling or refreshing your space, our AI room planner and virtual interior design app help you visualize layouts, preview real furniture, and explore decorating ideas, all tailored to your room and style."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>AI Room Design Generator Built for Real Homes</H2>
            </Show>
            <Text>
              Turn your space into a designer room — instantly. Upload a photo, choose your room type, style, and colors, and our AI design generator will create a personalized, photorealistic layout in seconds. From cozy bedrooms to modern kitchens,
              this AI room layout app uses intelligent spatial planning, trending decor styles, and realistic lighting to bring your vision to life — no measuring or guesswork required. Discover how easy it is to decorate your home with AI using real
              furniture and personalized layouts.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>AI Room Design Generator Built for Real Homes</H2>
            </Show>
            <Image src={img1} alt="User uploading photo to AI room planner app to generate personalized room design with furniture layout" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Smarter Home Decorating With Our AI Room Planner</H2>
            </Show>
            <Text>
              Explore your personal style with our AI-powered home design tools. From modern to farmhouse, boho to Japandi, the AI decorating app adapts to your taste. Choose your favorite colors, textures, and layout trends — and get instant,
              photorealistic room ideas you can tweak and refine. It's the easiest way to experiment with AI room design that feels truly personal.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Smarter Home Decorating With Our AI Room Planner</H2>
            </Show>
          </MobileHeading>
          <BeforeAfter />
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>AI-Generated Designs with Real Furniture</H2>
            </Show>
            <Text>
              Preview real furniture, lighting, and decor in your AI-generated space. With our AI room planner, you can test layouts, color palettes, and furniture placement using products from 30+ top brands. Then, use AR to view your design in your
              actual room. If you are furnishing a new home or upgrading your space, our AI home decorating app lets you shop confidently.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>AI-Generated Designs with Real Furniture</H2>
            </Show>
            <Image src={img3} alt="Mobile view of AI room design with real furniture previews and layout planner using AR technology" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img4} alt="DecorMatters app interface showcasing AI interior design features, home decorating games, and shopping tools" />
            <Content>
              <H2>Download the All-in-One AI Interior Design App Today</H2>
              <Text>
                DecorMatters is more than just an AI home design app — it's an all-in-one platform to create, visualize, and share your dream space. Play interior design games, complete AI-powered decorating challenges, earn badges, and build your
                home design portfolio. Whether you are planning your first apartment or a full renovation, download the free AI room design app and experience the most powerful AI design app for home decorating.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default AiInteriorDesign
